import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EnterpriseBasketService,
  EnterpriseSearchService,
  UserService,
  ParkingQuote,
  ServiceType,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';
import { FlightEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { BaseResultsComponent } from '../../../core/components/base_components/base-results.component';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-parking',
  templateUrl: './parking.component.html',
  styleUrls: ['./parking.component.scss'],
  standalone: false
})
export class ParkingComponent extends BaseResultsComponent implements OnInit {
  ServiceType: typeof ServiceType = ServiceType;
  showItemDetails: boolean[] = [];
  public visibleMapView = false;
  public flightSearchParams: FlightEnterpriseSearchInterface;

  constructor(
    public searchService: EnterpriseSearchService,
    public userService: UserService,
    public route: ActivatedRoute,
    public basketService: EnterpriseBasketService,
    translateService: TranslateService,
    titleService: Title,
    themeService: ThemeService,
    public modalService: ModalOpenerService,
    router: Router
  ) {
    super(titleService, translateService, themeService, searchService, userService, router);
    this.flightSearchParams = searchService.searches[ServiceType.Flight];
  }

  ngOnInit(): void {
    this.setResultsTitle('Parking results');
    this.initBaseResults();
    this.showItemDetails = [];
    this.subscribe(this.route.data, ({ type }) => {
      console.log(`Detected search type: ${type}`, 'PNL');
    });

    this.subscribe(this.searchService.searches[ServiceType.Parking].listViewToggle, (mapData) => {
      if (mapData === null) {
        this.restoreFocusToMapButton();
      }
    });
  }

  toggleItemDetails(index: number): void {
    this.showItemDetails[index] = !this.showItemDetails[index];
  }

  performSearch(): void {
    this.searchService.search_objects[ServiceType.Parking].chosen = true;
    this.searchService.determineHighestSearchPriority();
    this.searchService.startSearches();
  }

  addToCart(item: ParkingQuote) {
    this.searchService.searches[ServiceType.Parking].addParkingToBasket(
      item,
      this.searchService.searches[ServiceType.Parking].getSearchQuery()
    );
    this.basketService.toggleMenu();
  }

  skipToResultContent(): boolean {
    return super.skipToResultContent('parking');
  }

  private restoreFocusToMapButton(): void {
    const lastIndex = (this.searchService as any).lastFocusedParkingIndex;

    if (lastIndex !== undefined && lastIndex !== null) {
      setTimeout(() => {
        const button = document.getElementById(`parking-map-btn-${lastIndex}`);
        if (button) {
          button.focus();
        }
        (this.searchService as any).lastFocusedParkingIndex = null;
      }, 200);
    }
  }
}
